import { GET, POST } from '@/packge/http';
import { countDown, phoneCode, prePhoneCode, second } from '@/utils/setup/captchaInput';
import { ref, computed } from 'vue';
import { message } from 'ant-design-vue';
import router from '@/router';
import store from '@/store';

// const router = useRouter();

export let bindPhoneStep = ref(1);
export let phone = ref(''); // 绑定新手机
export let mobileVisible = ref(false);
export let userMobile = ref('');
userMobile.value = computed(() => store.state.userInfo.phonenumber);

/**
 * 统一 获取手机验证码
 * code 300704 提示新手机号不能和旧手机号一样
 * code 300716 手机号已经存在请重新输入
 * */
export function getCode (type) {
  if (second > 1) { return; }

  GET({
    url: '/account/getSmsCode',
    params: {
      type, // 1安全认证 2绑定手机 3绑定邮箱
      phone: type === 2 ? phone.value : undefined // 绑定新手机时需要
    }
  }).then(({ data }) => {
    bindPhoneStep.value === 1 && (bindPhoneStep.value++);
    countDown();
  });
}

/** 重绑手机 */
export function reBindPhone (platform = 'web') {
  return new Promise(resolve => {
    POST({
      url: '/account/bindPhone',
      params: { phone: phone.value, code: prePhoneCode() }
    }).then(({ data }) => {
      console.log('platform: ', platform);
      if (platform === 'web') {
        message.success('修改手机成功');
        phone.value = '';
        bindPhoneStep.value = 1;
        phoneCode.list.forEach(item => { item.value = ''; });
        mobileVisible.value = false;
        resolve();
      } else {
        message.success('修改手机成功');
        phone.value = '';
        bindPhoneStep.value = 1;
        phoneCode.list.forEach(item => { item.value = ''; });
        mobileVisible.value = false;
        setTimeout(() => {
          router.go(-2);
        }, 800);
      }
    });
  });
}
